import React, {useContext, useEffect, useState} from 'react';
import {makeStyles} from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import List from '@material-ui/core/List';
import {ListItemText} from '@material-ui/core';

import ListItem from '@material-ui/core/ListItem';
import SaveLanguageModal from '../SaveLanguageModal';

import _firebaseContext from '../../../contexts/firebaseContext';
import _appContext from '../../../contexts/appContext';

const LanguagesList = () => {
    const [isSaveLanguageVisible, setIsSaveLanguageVisible] = useState(false);
    const [languagesList, setLanguagesList] = useState([]);
    const classes = useStyles();
    const firebaseContext = useContext(_firebaseContext);
    const appContext = useContext(_appContext);
    const isLoading = appContext.loading;

    const saveLanguageVisibilityHandler = () => {
        setIsSaveLanguageVisible(!isSaveLanguageVisible);
    }

    const getLanguagesList = () => firebaseContext.getLanguages()
        .then(doc => setLanguagesList(doc))
        .catch((e) => console.log('getLanguagesList: ', e));

    useEffect(() => {
        (async () => {
            appContext.startLoading();
            await getLanguagesList();
            appContext.endLoading();
        })();
    }, []);

    const updateLanguagesList = (language) => {
        const currentLanguageIndex = languagesList.findIndex(item => item.id === language.languageId)
        if (currentLanguageIndex !== -1) {
            const languages = [...languagesList];
            languages[currentLanguageIndex] = {id: language.languageId, data: language};
            setLanguagesList(languages);
        } else {
            setLanguagesList([...languagesList, {id: language.languageId, data: language}])
        }
    }

    return (
        <>
            <Button
                variant='contained'
                color='default'
                onClick={saveLanguageVisibilityHandler}
                className={classes.addButton}
            >
                Добавить язык
            </Button>
            {
                !isLoading &&
                <>
                    {
                        !languagesList || languagesList.length === 0 ? (
                            <Typography className={classes.emptyList}>Нет добавленных языков</Typography>
                        ) : (
                            <List className={classes.languagesList}>
                                {languagesList.map((doc) => (
                                    <ListItem key={doc.id}>
                                        <ListItemText
                                            primary={doc.data.languageId}
                                            secondary={doc.data.represent}
                                            classes={{secondary: classes.languageSecondaryText}}
                                        />
                                    </ListItem>
                                ))}
                            </List>
                        )
                    }
                    <SaveLanguageModal
                        visibility={isSaveLanguageVisible}
                        modalVisibilityHandler={saveLanguageVisibilityHandler}
                        updateLanguagesList={updateLanguagesList}
                    />
                </>
            }
        </>
    )
}

const useStyles = makeStyles(theme => ({
    addButton: {
        marginTop: 15
    },
    languageSecondaryText: {
        textTransform: 'capitalize'
    },
    emptyList: {
        marginTop: 20
    },
    languagesList: {
        width: '100%',
        backgroundColor: theme.palette.background.paper
    }
}));

export default LanguagesList;
